import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Desktop = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 320,
    x: 32,
    y: 64,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    points: "304 448 296 384 216 384 208 448 304 448"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368,
    x2: 144,
    y1: 448,
    y2: 448,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z"
  }));
});
Desktop.displayName = 'Desktop';
export var DesktopDimensions = {
  height: 512,
  width: 512
};